export const NEWS_ACTIVITIES_BASE_URL = '/news-activities';

export const NEWS_ACTIVITIES_EVENT_NAME = 'news-activities-click';
